module.exports = __webpack_public_path__ + "static/media/Score-Elite.93f5517a.svg";